import times from 'lodash/times';
export const _times = times;
